import { ManagebeneficiariesIcon } from "../../Icons";

const CardButtonSubAccount = ({ title, subtitle }) => {
  return (
    <div className="add-new-card-button-wrapper-sub-account">
      <div className="add-new-card-icon">
        <ManagebeneficiariesIcon />
      </div>
      <div className="pl-3">
        <h3 className="add-new-card-title">{title}</h3>
        <p className="add-new-card-subtitle">{subtitle}</p>
      </div>
    </div>
  );
};
export default CardButtonSubAccount;
